import gql from 'graphql-tag'

export const validPlateOrIdQuery = gql`
  query identificadoresPJV2(
    $idConta: String!
    $placa: String
    $identificador: String
    $gerencial: Boolean
    $pagina: Int
    $quantidade: Int
  ) {
    identificadoresPJV2(
      idConta: $idConta
      placa: $placa
      identificador: $identificador
      gerencial: $gerencial
      pagina: $pagina
      quantidade: $quantidade
    ) {
      identificadores {
        idIdentificador
        codIdentificador
        veiculo {
          placa
        }
      }
    }
  }
`

export const gqlHistoricoIdentificadorTag = gql`
  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {
    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {
      id
      pap
      placa
      historicos {
        codIdentificador
        dataInclusao
        operacao
        placa
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/query.js